import React from 'react';
import PropTypes from 'prop-types';
import { Box, Toolbar } from '@mui/material';
import GetAppIcon from '@mui/icons-material/GetApp';

import CustomSearch from 'components/common/customSearchV2';
import CustomFilter from 'components/common/customFilter';
import CustomToolbarAction from 'components/common/customToolbarAction';

import M from 'messages';

import classes from './styles';

const CustomTableToolbar = props => {
  const {
    onSearchCallback,
    filteredParams,
    onFilterCallback,
    filterFields,
    handleExport,
    exportAbility = true,
    searchAbility = true,
  } = props;

  const searchValue = filteredParams?.params?.search?.value || '';

  return (
    <Toolbar sx={classes.root}>
      <Box sx={classes.filters}>
        {searchAbility && <CustomSearch onSearchCallback={onSearchCallback} searchValue={searchValue} />}
        <CustomFilter onFilterCallback={onFilterCallback} filterFields={filterFields} filteredParams={filteredParams} />
      </Box>
      <Box sx={classes.actions}>
        {handleExport && (
          <CustomToolbarAction
            handleOnClick={handleExport}
            btnText={M.get('actions.export')}
            tooltipText={M.get('actions.export')}
            startIcon={<GetAppIcon />}
            isAvailable={exportAbility}
          />
        )}
      </Box>
    </Toolbar>
  );
};

CustomTableToolbar.propTypes = {
  onSearchCallback: PropTypes.func.isRequired,
  filteredParams: PropTypes.instanceOf(Object).isRequired,
  onFilterCallback: PropTypes.func.isRequired,
  filterFields: PropTypes.instanceOf(Object).isRequired,
  handleExport: PropTypes.func,
  exportAbility: PropTypes.bool,
  searchAbility: PropTypes.bool,
};

export default CustomTableToolbar;
